/**
 * Created by dx.yang on 16/4/27.
 */

var defaultOptions = {
    totalRows: 1,
    current: 1,
    ends: 1,
    span: '...',
    show: 5,
    rowsPerPage: 1,
    rowsOptions: [10, 20, 30, 50]
};


function looper(all, s, e){
    for(; s <= e; s++){
        all.push(s);
    }
}

function createPages(op) {
    var  {
        total,
        current,
        show,
        span,
        ends
    } = op;


    var all = [];
    var left = [];
    var leftSpan = span;
    var rightSpan = span;
    var right = [];

    var offset, contentLeft, contentRight;

    if(total <= show){
        looper(all, 1, total);
    }else{
        offset = ~~(show / 2);
        offset = offset == (show / 2) ? offset - 1 : offset;
        contentLeft = current - offset;
        contentRight = current + offset;

        if(contentLeft < 1){
            contentRight = contentRight - contentLeft + 1;
            contentLeft = 1;
        }

        if(contentRight > total){
            contentLeft = contentLeft - contentRight + total;
            contentRight = total;
        }

        if (contentLeft - ends <= 2) {
            contentLeft = 1;
            leftSpan = null;
        }else{
            left = [1, ends];
        }

        if(contentRight + ends >= total - 1){
            contentRight = total;
            rightSpan = null;
        }else{
            right = [total - ends + 1, total];
        }

        if(left.length){
            looper(all, left[0], left[1]);
        }

        if(leftSpan){
            all.push(leftSpan);
        }

        looper(all, contentLeft, contentRight);

        if(rightSpan){
            all.push(rightSpan);
        }

        if(right.length){
            looper(all, right[0], right[1]);
        }

    }

    var str = '';
    var active = '';
    var i = 0;
    var len = all.length;
    var v;
    for( ; i < len ; i++){
        v = all[i];
        active = '';
        if(v == current) {
            active = 'active';
        }
        if(v == span) {
            active = 'ellipsis';
        }
        str += `
            <a class="page-num ${active}" href="javascript:;" data-num="${v}">
            ${v}
            </a>
        `;
    }

    str = `
        <a href="javascript:;" class="page-num prev" data-num="${op.current - 1}">
            <span class="prev-caret"></span>
        </a>
        ${str}
        <a href="javascript:;" class="page-num next" data-num="${op.current + 1}">
            <span class="next-caret"></span>
        </a>
    `;
    return str; 
}

export default {
    name: 'KsPages',
    data() {
        return {
            rowsPerPage: 10,
            showSelect: false
        };
    },
    props: {
        value: {
            type: Object,
            default: () => {}
        }
    },
    // props: {
    //     // options: {
    //     //     type: Object,
    //     //     required: true,
    //     //     default: () => {}
    //     // }
    // },
    watch: {
        // options: {
        //     deep: true,
        //     handler() {
        //         this.rowPerPage = this.options.rowPerPage;
        //     }
        // },
        rowsPerPage() {
            if (this.rowsPerPage != this.value.rowsPerPage) {
                let v = _.cloneDeep(this.value);
                v.rowsPerPage = this.rowsPerPage;
                this.$emit('input', v);
                //console.log(this.rowPerPage);
            }
        }
    },
    computed: {
        _op() {
            // console.log(this.value, 111);
            let op = _.assign({}, defaultOptions, this.value)
            let total = op.totalRows / op.rowsPerPage;
            if (total > ~~total) {
                total += 1;
            }
            op.total = ~~total;
            if (op.current > op.total) {
                op.current = 1
            }
            return op;
        },
        _all() {
            return createPages(this._op);
        }
    },
    created() {
        // console.log(this.value);
    },
    mounted() {
        let me = this;
        me.rowsPerPage = me.value.rowsPerPage;
        me.$nextTick(() => {
            $(me.$el).on('click', '.page-num', function() {
                let num = $(this).data('num');
                if (num < 1 || num > me._op.total || num === me._op.span) {
                    return;
                }
                let v = _.cloneDeep(me.value);
                v.current = num;
                me.$emit('input', v);
                // me.options.current = num;
            });
        });
    },
    methods: {
        toggleSelect() {
            this.showSelect = !this.showSelect; 
        },
        changeRowsPerPage(v) {
            this.value.rowsPerPage = v;
            this.value.current = 1;
            this.showSelect = false;
        }
    }
}